module.exports = __webpack_public_path__ + "static/media/print.bcb6d1cf.svg";